import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import customerService from "services/customerService";
import subscriptionService from "services/subscriptionService";
import * as model from "models/subscription";
import { settings } from "settings";

const initialState = {
	isSubmitting: false,
	entity: model.subscription,
	wineClub: null,
};

export const setWinClub = (wineClub) => (dispatch) => {
	dispatch(
		setSubscription({
			subscriptionType: model.subscriptionTypes.wineClub,
			wineClubId: wineClub.id,
			bottles: wineClub.bottles,
			frequency: wineClub.frequency,
			price: wineClub.price,
			subscriptionShippingMonths: wineClub.shippingMonths.nodes.map(
				(month) => ({
					monthName: month.monthName,
					monthNumber: month.monthNumber,
					monthOrder: month.monthOrder,
				})
			),
			subscriptionProducts: wineClub.wineClubProducts.nodes.map((product) => ({
				quantity: product.quantity,
				variantId: product.variantId,
			})),
			collections: wineClub.collections,
		})
	);
};

export const createSubscription = createAsyncThunk(
	"subscription/create",
	async ({ subscription, user }, { dispatch }) => {
		try {
			dispatch(setSubmitting(true));
			dispatch(showLoader());
			dispatch(setPaymentMethod(subscription.paymentMethod));
			let customerId;
			if (!user.isUserLoaded) {
				const { customer, shippingAddress } = subscription;
				customerId = await customerService.create({
					customer: {
						...customer,
						address: {
							...shippingAddress,
						},
					},
				});
			}
			await subscriptionService.create(subscription, customerId);

			dispatch(
				showMessage({
					message: "Your subscription created successfully.",
					variant: "success",
				})
			);
			dispatch(resetSubscription());
			location.href = settings.urls.wines;
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					message: "Error occurred while creating subscription",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
			dispatch(setSubmitting(false));
		}
	}
);

const subscriptionSlice = createSlice({
	name: "vino/subscription",
	initialState,
	reducers: {
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
		setSubscription: (state, action) => {
			state.entity = {
				...state.entity,
				...action.payload,
			};
		},
		setCustomer: (state, action) => {
			state.entity = {
				...state.entity,
				customer: action.payload,
			};
		},
		setShippingAddress: (state, action) => {
			state.entity = {
				...state.entity,
				shippingAddress: action.payload,
			};
		},
		setShippingAddressId: (state, action) => {
			state.entity = {
				...state.entity,
				shippingAddressId: action.payload,
			};
		},
		setPaymentMethod: (state, action) => {
			state.entity = {
				...state.entity,
				paymentMethod: action.payload,
			};
		},
		setPaymentMethodId: (state, action) => {
			state.entity = {
				...state.entity,
				paymentMethodId: action.payload,
			};
		},

		resetSubscription: () => initialState,
	},
	extraReducers: {},
});

export const {
	setSubmitting,
	setSubscription,
	setCustomer,
	setPaymentMethod,
	setPaymentMethodId,
	setShippingAddress,
	setShippingAddressId,
	resetSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
